/**
 * <s-age-gate> — opens the 18+ modal on the first visit and remembers the
 * visitor's confirmation so it is not shown again on this device.
 */
const STORAGE_KEY = 'ageVerified';

class SAgeGate extends HTMLElement {
  #ac;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const designMode = this.hasAttribute('data-design-mode');

    this.querySelector('[data-age-confirm]')?.addEventListener('click', () => {
      if (!designMode) {
        try { localStorage.setItem(STORAGE_KEY, 'true'); } catch (e) { /* storage unavailable */ }
      }
      dialog.close();
      // Lets pop-ups that wait for the age check (gift offer, chat) start their timers.
      document.dispatchEvent(new CustomEvent('age-gate:verified'));
    }, { signal });

    // Escape must not skip the age check.
    dialog.addEventListener('cancel', (event) => event.preventDefault(), { signal });

    if (designMode) {
      dialog.show();
      return;
    }

    let verified = false;
    try { verified = localStorage.getItem(STORAGE_KEY) === 'true'; } catch (e) { /* storage unavailable */ }
    if (!verified && !dialog.open) dialog.showModal();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-age-gate')) customElements.define('s-age-gate', SAgeGate);
